module.exports = __webpack_public_path__ + "assets/favicon-bf-uk.786de6fe.png";